import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { IPetNoteModel, PetNoteModel } from '@common/models/PetNoteModel';

export class PetNoteService {
  private static baseUrl: string = '/api/petNote';

  public static tags = {
    upsertPetNote: 'upsertPetNote',
  };

  static upsertPetNote = (request: IPetNoteModel): Promise<PetNoteModel> =>
    trackPromise(
      new Promise<PetNoteModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IPetNoteModel>(request)
          .then((json) => resolve(new PetNoteModel(json)))
          .catch(reject);
      }),
      this.tags.upsertPetNote,
    );
}
